// extracted by mini-css-extract-plugin
export default {"SideDrawer":"SideDrawer_SideDrawer__qAWd8","Open":"SideDrawer_Open__0u6N9","Close":"SideDrawer_Close__eBZRV"};